/*eslint no-console: ["error", { allow: ["warn", "error"] }] */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { axios } from "~/libs/vp-api-axios";
export const FacebookLogin ={
  data () {
    return {
      fbLogin: false,
      cheered: false,
      followed: false,
      fbSdkIsLoaded: false,
    };
  },
  methods: {
    getLoginStatus() {
      if(this.session == null) {
        if (typeof window.FB === "undefined" ) { return; }
        window.FB.getLoginStatus(function (response) {
          this.fbSdkIsLoaded = true;
          this.statusChangeCallback(response);
        }.bind(this));
      } else {
        this.createVisitorWithFbData();
      }
    },
    facebookLogin() {
      window.FB.login(function(response) {
        this.statusChangeCallback(response);
      }.bind(this),{ scope: "public_profile,email" });
    },
    statusChangeCallback(response) {
      if (response.status === "connected") {
        this.setFbSession(response.authResponse);
      } else {
        this.resetFbSession();
      }
    },
    setFbSession(authResponse) {
      // セッションにFBのauth tokenを入れる
      axios.post("/api/social_api/callback_fb", authResponse)
        .then((result) => {
          // アクセストークンを確かめられなかったときは、set_fbを呼んでもエラーになるだけなので打ち切る
          if (result.data.status !== true) {
            window.webpackBugsnagClient?.notify("Facebookのアクセストークンを確かめられませんでした");
            return;
          }
          this.createVisitorWithFbData();
        })
        .catch((err) => { console.error(err); });
    },
    createVisitorWithFbData() {
      axios.post("/api/social_api/set_fb", {
        articleId: this.articleId,
        corporationId: this.userAccountId
      })
        .then( (result) => {
          // failed
          if (result.data.status !== 1) {
            if (this.sesseion == null){
              console.warn("Facebookとのセッションが切れていますログインしてください");
            } else {
              console.error("error");
            }
          }
          // success
          else {
            if (result.data.data.isCheered) { this.cheered = true; }
            this.followed = result.data.data.isFollowed;
            this.fbLogin = true;
          }
        })
        .catch((err) => { console.error(err); });
    },
    resetFbSession() {
      $.ajax({
        type: "GET",
        url: "/api/social_api/check",
        cache: false
      });
    }
  }
};
